type ReportHandler = (metric: any) => void;

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  // 暂时禁用 web-vitals 以避免类型错误
  console.log('Web vitals reporting disabled');
};

export default reportWebVitals;
